export const locale = {
    lang: 'zh2',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': '两步验证',
          'SUBTITULO': '为了在进入平台时提供更高的安全性，您需要执行如下所示的两步验证',
          'BOTONES': {
            'SIGUIENTE': '下一个',
            'ANTERIOR': '以前的'
          },
          'PASOS': {
            '1': {
              'TITULO': '步骤1',
              'INSTRUCCION': '使用 Google Authenticator 移动应用扫描二维码，然后单击下一步按钮',
              'REGISTRADO': '检测到您的邮箱已经在谷歌身份验证器应用中注册，无需再次扫描二维码，继续下一步'
            },
            '2': {
              'TITULO': '第2步',
              'INSTRUCCION': '输入 Google Authenticator 提供的密钥，然后单击下一步 ',
              'INPUT': '获得的钥匙',
              'INFOPREVIA': {
                'INFO_1': '检测到您已经从这台电脑访问过平台。 无需再次扫描二维码',
                'INFO_2': '只需输入 Google Authenticator 为您的帐户提供的密码，然后单击下一步',
                'INFO_3': '如果您想再次扫描二维码，请单击“上一步”按钮',
                'INFO_4': '警告：这样做，您将不得不再次将您的帐户链接到 Google 身份验证器',
              }
            },
            '3': {
              'TITULO': '结果',
              'INSTRUCCION': '输入上一步从二维码中获取的密钥，然后单击下一步按钮',
              'VALIDANDO': '验证输入的密钥，稍等片刻',
              'MAL': '密钥不正确或已过期，请重新输入密钥并重试',
              'BIEN': '您已成功完成认证，然后您将进入平台'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'请输入您的电子邮件地址，我们将向您发送更改密码的链接',
          'BTN':'发送电子邮件',
          'PLACERHOLDER':'电子邮件地址',
          'ERROR':'我们找不到您的电子邮件。请尝试其他电子邮件',
          'TRUE':'电子邮件已发送，请检查您的收件箱或垃圾邮件文件夹'
        },
        'RESET':{
          'LABEL01':'请...输入用户的新密码：   ',
          'LABEL02':'密码',
          'LABEL03':'重新输入密码',
          'BTN':'Change password',
          'ERROR':'错误，找不到令牌',
          'NOPASSWORDMATCH':'密码不匹配',
          'CARACTERES':'必须至少3个字符',
          'SUCCESSCHANGE':'您的密码已正确更改'
        },
        'LANDING': {
          'MENSAJE':	'欢迎',
          'NAVEG':	'建议使用<a class="linkChrome" href="https://www.google.com/intl/es-419/chrome/" target="blank"> Google Chrome </a>浏览器',
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': '重要公告。',
            'TEXTO': `尊敬的用户：<br><br>
             通知您，为了提供更好的服务，文化GO平台将进行更新以优化其运营。<br><br>
             更新将于 <strong>7 月 23 日星期五晚上 11:59 开始。 直到晚上 11:59 7 月 24 日星期六</strong>。 在此期间，平台将保持不活动状态。 但是，当前的调查将保持有效。<br><br>`
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'找回密码',
          'TITULO':	'登录您的账户',
          'INPUT':{
            'EMAIL':	'电子邮件',
            'PASSWORD':	'密码',
            'LANGSEL':	'选择语言',
          },
          'VAL': {
            'NOTEMAIL':	'电子邮件为必填',
            'INVEMAIL':	'请输入有效的电邮地址',
            'CARACT_EMA': ' 字段不允许以下字符 /&¿+#$%([=])*?"<>:\'',
            // 'PASS':	'密码为必填',
            'PASS': '无效密码',

          },
          'SIGNIN':	'进入!',
          'CAMBIALOGO': '点击此处更改您的公司徽标',
          'CARGAOK': '您的公司徽标已正确加载',
          'CARGANULL': '加载您的公司徽标时出错',
          'CARGAERROR': '所选文件的格式不正确。 仅接受格式：jpg，png，gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'PASSWORD': '密码',
            'LANGSEL': '选择一种语言',
            'LOGIN':'登录',
          },

      },
      'INTRO-LOGIN':{
        'TITULO':'使用说明',
        'TEXT1':'工作场所®学院。欢迎您100％保密地回答您的工作环境调查',
        'TEXT2':'机密性',
        'TEXT3':'在研究所:',
        'TEXT4':'我们按组织和领域管理,处理,统计分析响应。',
        'TEXT5':'我们产生的全球结果表明了组织环境中的改进措施。',
        'TEXT6':'您不知道个人的回答',
        'TEXT7':'个人回复严格保密,',
        'TEXT8':'投诉和建议',
        'TEXT9':'严格禁止:',
        'TEXT10':'您以任何方式受到影响,受到惩罚或受到阻止,无法自由回答调查。',
         'TEXT11':'我们向您发送以下电子邮件,以提出投诉或建议:',
         'TEXT12':'mx_transparencia@greatplacetowork.com',
         'TEXT13':'说明:',
         'TEXT14':'1。输入您的 ',
         'TEXT15':'雇员编号+出生年份。',
         'TEXT16':'2。请勿留空格。',
         'TEXT17':'3。单击开始。',
         'TEXT18':'帮助我们回答“工作场所®学院”调查！！',
      }
},
'LOADING':{
  'TEXT_WELCOM':'欢迎来到CulturalGo',
  'TEXT_CHANGE':'正在加载信息...',
}

    }
};
